export default async ({ app }) => {
    await app.store.dispatch('main/setLocale', {
        locale: app.store.state.main.locale,
    });
};
